import { Effect, Reducer } from '@umijs/max';

import { getLoanTypes } from '@/services/loans.service';

import { LoanType } from '@/interfaces/loans';
import { getMyAffiliates } from '@/services/user.service';
import { Affiliate } from '@/interfaces/affiliates';

export interface ModelType {
  namespace: string;
  state: { loanTypes: LoanType[]; affiliates: Affiliate[] };
  effects: {
    fetchData: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'myLoans',

  state: {
    loanTypes: [],
    affiliates: [],
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      const [loanTypes, affiliates] = yield all([
        call(getLoanTypes, payload),
        call(getMyAffiliates, payload),
      ]);
      yield put({
        type: 'setData',
        payload: { loanTypes, affiliates },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
